import { Box, Skeleton } from '@mui/material';
import HeaderFallback from './components/header.fallback';

const GatewayDashboardFallback = () => {
    return (
        <HeaderFallback title="داشبورد درگاه">
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1.8,
                    width: '100%',
                }}>
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: {
                            xs: '1fr',
                            sm: 'repeat(2, minmax(0, 1fr))',
                            xl: 'repeat(4, minmax(0, 1fr))',
                        },
                        gap: 1.4,
                    }}>
                    {Array.from({ length: 4 }).map((_, index) => (
                        <Skeleton
                            key={index}
                            variant="rounded"
                            height={154}
                            sx={{ borderRadius: '18px' }}
                        />
                    ))}
                </Box>

                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: {
                            xs: '1fr',
                            lg: 'minmax(0, 1.62fr) minmax(330px, 0.78fr)',
                        },
                        gap: 1.8,
                    }}>
                    <Skeleton
                        variant="rounded"
                        height={410}
                        sx={{ borderRadius: '18px' }}
                    />
                    <Skeleton
                        variant="rounded"
                        height={410}
                        sx={{ borderRadius: '18px' }}
                    />
                </Box>

                <Skeleton
                    variant="rounded"
                    height={380}
                    sx={{ borderRadius: '18px' }}
                />
            </Box>
        </HeaderFallback>
    );
};

export default GatewayDashboardFallback;
